export default __webpack_public_path__ + "static/media/gm-sbo-girl.ce7e77ad.webp";